// 帮助中心
import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 问题状态
 */
class State extends UltMeta {
    UP_SHELF = new Meta(1, "上架");
    DOWN_SHELF = new Meta(0, "下架", "color-info");
}

export const STATE = new State();
